module.exports = __webpack_public_path__ + "img/da8bcd2407db28879de5c612c06d496d.c3d01fe8.png";